module.exports = __webpack_public_path__ + "font_kacho.152253b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/font_kacho.png
// module id = GjrF
// module chunks = 0